import React, { useState } from "react";
import msgFrame from "../assets/msg frame.png";
import phoneFrame from "../assets/phone frame.png";
import locationFrame from "../assets/location frame.png";
import peopleFrame from "../assets/people frame.png";
import bookFrame from "../assets/book frame.png";
import heartFrame from "../assets/heart frame.png";
import logo from '../assets/logo PNG Transparent/Logo-14.png';
import downArrowFrame from '../assets/down arrow frame.png';
const Footer = () => {
  const [expanded, setExpanded] = useState(false); // ✅ Move inside the component

  return (
    <footer className="pt-12 pb-8 pl-4 pr-4 sm:pl-12 sm:pr-12 bg-transparent border-t border-gray-200 mt-auto w-full">
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-10 justify-items-start items-start text-left">
        {/* Left: Logo and description */}
        <div>
          <img src={logo} alt="HWork2" style={{ height: '45px', width: 'auto', marginBottom: '12px' }} />
          <p className="text-sm text-gray-600 max-w-md">
            HWork2 is a self-discovery platform built to help you uncover your strengths, passions, values, and true potential through a suite of unique, deeply personal assessments. Each test offers practical, easy-to-understand insights that guide you toward greater self-awareness and authentic growth — empowering you to live with more clarity, confidence, and purpose.
          </p>
        </div>

        {/* Middle: Navigation Links */}
        <div className="text-left" style={{ paddingLeft: '80px' }}>
          <h4
            className="mb-3"
            style={{
              width: '154px',
              height: '24px',
              transform: 'rotate(0deg)',
              opacity: 1,
              fontFamily: 'Lato, sans-serif',
              fontWeight: 700,
              fontStyle: 'normal',
              fontSize: '20px',
              lineHeight: '100%',
              letterSpacing: '0%',
              color: '#000000',
              whiteSpace: 'nowrap'
            }}
          >
            Navigation Links:
          </h4>
          <ul className="text-sm text-[#9E9FA0] space-y-2 text-left">
            <li><a href="/about" className="hover:underline">About</a></li>
            <li><a href="/personality-test" className="hover:underline">Tests</a></li>
            <li><a href="/compass" className="hover:underline">Compass</a></li>
            <li><a href="/method" className="hover:underline">Our Method</a></li>
            <li><a href="/faq" className="hover:underline">FAQ</a></li>
            <li><a href="/pricing" className="hover:underline">Pricing</a></li>
            <li><a href="/login" className="hover:underline">Login</a></li>
          </ul>
        </div>

        {/* Right: Disclaimer */}
        <div>
          <h4
            className="mb-3"
            style={{
              width: '375px',
              height: '22px',
              transform: 'rotate(0deg)',
              opacity: 1,
              fontFamily: 'Lato, sans-serif',
              fontWeight: 600,
              fontStyle: 'normal',
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '0%',
              color: '#000000'
            }}
          >
            Disclaimer:
          </h4>
          <p className="text-sm text-[#9E9FA0] max-w-sm">
            The Site does not offer professional or definitively accurate advice or opinions regarding products or services. The information and opinions provided are for entertainment and educational purposes only and should not replace professional advice.
            {expanded && (
              <> Therefore, before making any decisions based on your scores, we recommend consulting with appropriate professionals. ANY USE OR RELIANCE ON INFORMATION FOUND ON THE SITE IS AT YOUR OWN RISK.</>
            )}
          </p>
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-2 flex items-center gap-2 text-[#7A81FF] hover:text-[#5d63ff] underline"
            style={{ fontSize: '16px' }}
          >
            {expanded ? 'Read less' : 'Read more'}
            <img
              src={downArrowFrame}
              alt="toggle"
              className={`inline-block transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
              style={{ width: '16px', height: '16px' }}
            />
          </button>
        </div>
      </div>

      {/* Bottom row */}
      <div
        className="pt-6 mt-8 border-t border-gray-100 text-center"
        style={{
          width: '1280px',
          height: '14px',
          transform: 'rotate(0deg)',
          opacity: 1,
          fontFamily: 'Lato, sans-serif',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: '12px',
          lineHeight: '100%',
          letterSpacing: '0%',
          color: '#6B7280',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        © 2025 The HWork2 Method, Inc. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
